import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconChevronDown from '@assets/Icon/svg/IconChevronDown';
import IconChevronUp from '@assets/Icon/svg/IconChevronUp';
import { styContainerAccordion, styTitleAccordion, styleBodyAccordion } from './style';

/**
 * General Error Component
 * @param data Array Object [{ title: string , body: string }]
 * @param defaultOpen index of card you want default open
 * @returns
 */
const Accordion = ({ data, defaultOpen }) => {
  const [indexOpen, setIndexOpen] = useState(defaultOpen);

  const handleOpen = (index) => setIndexOpen(index);
  const handleClose = () => setIndexOpen(null);

  const removeTags = (text) => {
    if (!text) return '';
    const txt = text;
    const rex = /(<([^>]+)>)/gi;
    const removeHtml = txt?.replace(rex, '');
    return removeHtml.replaceAll(/&nbsp;/g, ' ');
  };

  return (
    <div>
      {data?.map((v, index) => (
        <div className={styContainerAccordion} key={index}>
          <div className={styTitleAccordion}>
            {v?.title}
            {indexOpen !== index && (
              <div onClick={() => handleOpen(index)} style={{ cursor: 'pointer' }}>
                <IconChevronDown />
              </div>
            )}
            {indexOpen === index && (
              <div onClick={handleClose} style={{ cursor: 'pointer' }}>
                <IconChevronUp />
              </div>
            )}
          </div>
          {indexOpen === index && <div className={styleBodyAccordion}>{removeTags(v?.body)}</div>}
        </div>
      ))}
    </div>
  );
};

Accordion.propTypes = {
  data: PropTypes.array,
  defaultOpen: PropTypes.number,
};

Accordion.defaultProps = {
  data: [{ title: '', body: '' }],
  defaultOpen: null,
};

export default Accordion;
